module.exports = __webpack_public_path__ + "img/master-class.95efc5c9.jpg";